export const environment = {
  production: false,
  apiUrl: "https://api.ews.katdev.com/api/v1",
  // apiUrl: "http://localhost:3000/api/v1",
  appName: "EWS - Admin",
  version: "1.0.0",
  logLevel: "debug",
  sessionInactivityMs: 5 * 60 * 1000,
  sessionWarningResponseMs: 60 * 1000,
  sessionActivityThrottleMs: 2000,
};
